import { useState, useEffect } from 'react';
import { parseUTC } from '../../utils/dateUtils';

export default function TimeInQueue({ createdAt }) {
  const [minutes, setMinutes] = useState(0);

  useEffect(() => {
    function calc() {
      const diff = Date.now() - parseUTC(createdAt).getTime();
      setMinutes(Math.max(0, Math.floor(diff / 60000)));
    }
    calc();
    const interval = setInterval(calc, 30000);
    return () => clearInterval(interval);
  }, [createdAt]);

  if (minutes < 60) {
    return <span className="time-in-queue">{minutes}m</span>;
  }
  const hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return <span className="time-in-queue">{hrs}h {mins}m</span>;
}
